import React from 'react';

import { useRouter } from 'next/router';
import PropTypes from 'prop-types';

import useCioBrowseAndGqlProducts from '../../hooks/useCioBrowseAndGqlProducts';
import useSelectedFacetsToApply from '../../hooks/useSelectedFacetsToApply';
import { groupSizeFacets } from '../../utils/filters';
import {
  getNewQueryParamString,
  QueryParamBehavior,
} from '../../utils/routing';

import MobileGridFilterRenderer from './MobileGridFilterRenderer';
import MobileGridSelectedFilters from './MobileGridSelectedFilters';

const MobileGridFiltersPane = ({ setShowOverlay = () => {} }) => {
  const { cioFacets } = useCioBrowseAndGqlProducts();
  const groupedFacets = groupSizeFacets(cioFacets);
  const router = useRouter();

  const { selectedFacetsToApply } = useSelectedFacetsToApply();

  const handleApplyFilters = () => {
    const [aspathname, query] = router.asPath.split('?');
    const newQueryParamString = getNewQueryParamString({
      query,
      newQueryParams: selectedFacetsToApply,
      queryParamBehavior: QueryParamBehavior.REPLACE,
    });

    router.push(router.pathname, `${aspathname}?${newQueryParamString}`, {
      shallow: true,
    });

    setShowOverlay(false);
  };

  return (
    <div className="relative h-full">
      {/* Temp push down until we fix overlay positioning */}
      <div className="h-[200px]" />
      <MobileGridSelectedFilters />
      <ul className="flex flex-col">
        {groupedFacets?.map((facet) => (
          <li key={facet?.name} className="[&:not(:last-child)]:border-b-2">
            <MobileGridFilterRenderer facet={facet} />
          </li>
        ))}
      </ul>
      <button
        type="button"
        disabled={!Object.keys(selectedFacetsToApply)?.length}
        className="absolute bottom-0 w-full py-2 bg-blue-500 text-white text-center disabled:bg-gray-300"
        onClick={handleApplyFilters}
      >
        Apply Filters
      </button>
    </div>
  );
};

MobileGridFiltersPane.propTypes = {
  setShowOverlay: PropTypes.func,
};

export default MobileGridFiltersPane;
